import { csx } from '@vtex/admin-ui'

export const menuButton = csx({
  flexDirection: 'row',
  backgroundColor: '$neutralTertiary',

  '&&&[data-open="true"]': {
    background: 'transparent !important',
    color: 'var(--admin-ui-fg-action-neutral-tertiary) !important',
  },

  '&&&[data-open="true"]:hover': {
    backgroundColor: 'var(--admin-ui-bg-grayTransparent05) !important',
    color: 'var(--admin-ui-fg-action-neutral-tertiaryHover) !important',
  },

  'svg:first-of-type': {
    display: 'none',
  },
})

export const menuActions = csx({
  left: '45px',
})
